<template>
  <div class="about" style="padding:15px">
    <q-card bordered class="my-card">
      <q-card-section class="bg-purple-6 text-white">
        <div class="row">
          <div class="col-12 col-md-9">
            <div class="row" style="margin: 0 5px 2px">
            <div class="text-h6">Data Pelaku Industri Rumah Tangga</div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="row" style="margin: 0 5px 2px">
              <q-input color="light-blue-7" v-model="cari_value" @keyup="cari_data()" outlined square :dense="true" class="bg-white" style="width:85%"/>
              <q-btn glossy class="bg-light-blue-7" @click="mdl_add = true" dense flat icon="add" style="width:15%">
                <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                  Tambah Data
                </q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card-section>

      <q-separator dark inset />

      <q-card-section>
        <div class="tbl_responsive">
          <!-- =================================================== KONTENT =========================================================== -->
            <table width="100%">
              <tr class="h_table_head bg-purple-2">
                <th width="2.5%" class="text-center">No</th>
                <th width="15%">Pelaku UMKM</th>
                <th width="10%">Kontak</th>
                <th width="12.5%">Badan Usaha</th>
                <th width="15%">Alamat</th>
                <th width="12.5%">Wilayah</th>
                <th width="7.5%" class="text-center">#</th>
              </tr>
              <tr class="h_table_body" v-for="(data, index ) in list_data" :key="data.id">
                <td class="text-center">{{index+1}}</td>
                <td>{{data.nama}} <div><q-badge outline rounded color="purple-12" style="font-size: 10px;">{{data.nik}}</q-badge></div></td>
                <td>{{data.email}} <div><q-badge outline rounded color="purple-12" style="font-size: 10px;">{{data.hp}}</q-badge></div></td>
                <td>{{data.badan}}</td>
                <td>{{data.alamat}}</td>
                <td>{{data.nama_kecamatan}} <div style="font-size: 10px;" class="q-pt-xs text-purple-12">{{data.nama_des_kel}}</div></td>
                <td class="text-center">
                  <q-btn-group>
                    <q-btn @click="mdl_lihat = true, selectData(data)" glossy color="cyan-7" icon="text_snippet" class="tbl_btn">
                      <q-tooltip class="bg-cyan-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Lihat Data
                      </q-tooltip>
                    </q-btn>
                    <q-btn @click="mdl_edit = true, selectData(data)" glossy color="amber-7" icon="create" class="tbl_btn">
                      <q-tooltip class="bg-amber-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Edit Data
                      </q-tooltip>
                    </q-btn>
                    <q-btn @click="mdl_hapus = true, selectData(data)" glossy color="deep-orange-7" icon="delete_forever" class="tbl_btn">
                      <q-tooltip class="bg-deep-orange-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Hapus Data
                      </q-tooltip>
                    </q-btn>
                  </q-btn-group>
                </td>
              </tr>
            </table>

          <!-- =================================================== KONTENT =========================================================== -->
        </div>
        <hr class="hrpagin">
        <br>
        <div class="text-center">
          <q-btn @click="btn_prev" glossy color="purple-6" icon="skip_previous" class="paginate_btn" />
            <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
          <q-btn @click="btn_next" glossy color="purple-6" icon="skip_next" class="paginate_btn" />
        </div>
        <br>
      </q-card-section>
    </q-card>

          <!-- =================================================== MODAL =========================================================== -->

            <!-- ================================================= MODAL TAMBAH ================================================ -->
              <q-dialog v-model="mdl_add" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-light-blue-7">
                    <div class="text-h6 h_modalhead">Tambah Data</div>
                  </q-card-section>

                  <form @submit.prevent="addData()">
                    <q-card-section class="q-pt-none">
                        <br>
                        <div class="row">
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Nama</span>
                            <q-input v-model="form.nama" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">NIK</span>
                            <q-input v-model="form.nik" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Nama Brand</span>
                            <q-input v-model="form.brand" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">Badan Usaha</span>
                            <q-input v-model="form.badan" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" />
                          </div>
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Email</span>
                            <q-input v-model="form.email" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">Nomor HP</span>
                            <q-input v-model="form.hp" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Kecamatan</span>
                            <q-select outlined dense v-model="form.kecamatan" @update:model-value="getDesKel" :options="list_kecamatan" option-label="nama_kecamatan" option-value="kecamatan_id" class="bg-white margin_input" />
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">Desa</span>
                            <q-select outlined dense v-model="form.des_kel" :options="list_des_kel" option-value="des_kel_id" option-label="nama_des_kel" class="bg-white margin_input" />
                          </div>
                          <div class="col-12 col-md-12">
                            <span class="h_lable">Alamat</span>
                            <q-input v-model="form.alamat" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-12 col-md-12">
                            <span class="h_lable">Profil</span>
                            <q-editor v-model="form.profil" min-height="10rem" class="bg-white margin_input" />
                          </div>
                        </div>

                    </q-card-section>

                    <q-card-actions class="bg-grey-3 mdl-footer" align="right">
                        <q-btn :loading="btn_add" color="light-blue-7" type="submit" label="Simpan" />
                        <q-btn label="Kembali" color="grey-7" v-close-popup />
                    </q-card-actions>
                  </form>

                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL TAMBAH ================================================ -->

            <!-- ================================================= MODAL LIHAT ================================================ -->
            <q-dialog v-model="mdl_lihat" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-cyan-7">
                    <div class="text-h6 h_modalhead">Lihat Data</div>
                  </q-card-section>
                  <q-card-section class="q-pt-none">
                    <br>
                    <span class="h_keterangan">{{form.profil}}</span>
                  </q-card-section>
                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
                  </q-card-actions>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL LIHAT ================================================ -->

            <!-- ================================================= MODAL EDIT ================================================ -->
            <q-dialog v-model="mdl_edit" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-amber-7">
                    <div class="text-h6 h_modalhead">Edit Data</div>
                  </q-card-section>

                  <form @submit.prevent="editData()">

                  <q-card-section class="q-pt-none">
                    <br>
                      <div class="row">
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Nama</span>
                            <q-input v-model="form.nama" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">NIK</span>
                            <q-input v-model="form.nik" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Nama Brand</span>
                            <q-input v-model="form.brand" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">Badan Usaha</span>
                            <q-input v-model="form.badan" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" />
                          </div>
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Email</span>
                            <q-input v-model="form.email" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">Nomor HP</span>
                            <q-input v-model="form.hp" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6" style="padding-right: 7.5px;">
                            <span class="h_lable">Kecamatan</span>
                            <q-select outlined dense v-model="form.kecamatan" @update:model-value="getDesKel" :options="list_kecamatan" option-label="nama_kecamatan" option-value="kecamatan_id" class="bg-white margin_input" />
                          </div>
                          <div class="col-6 col-md-6" style="padding-left: 7.5px;">
                            <span class="h_lable">Desa</span>
                            <q-select outlined dense v-model="form.des_kel" :options="list_des_kel" option-value="des_kel_id" option-label="nama_des_kel" class="bg-white margin_input" />
                          </div>
                          <div class="col-12 col-md-12">
                            <span class="h_lable">Alamat</span>
                            <q-input v-model="form.alamat" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-12 col-md-12">
                            <span class="h_lable">Profil</span>
                            <q-editor v-model="form.profil" min-height="10rem" class="bg-white margin_input" />
                          </div>
                        </div>

                  </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                    
                      <q-btn :loading="btn_add" color="amber-7" type="submit" label="Simpan"  />
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                  </form>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL EDIT ================================================ -->

            <!-- ================================================ MODAL HAPUS ================================================ -->
            <q-dialog v-model="mdl_hapus" persistent>
                    <q-card class="mdl-sm ">
                      <q-card-section class="q-pt-none text-center bg-deep-orange-3">
                          <form @submit.prevent="removeData(form.id)">
                              <br>
                              <img src="img/alert.png" alt="" width="75"> <br>
                              <span class="h_notifikasi">APAKAH ANDA YAKIN INGIN MENGHAPUS DATA INI??</span>
                              <input type="submit" style="position: absolute; left: -9999px"/>
                              <br>
                              <br>
                            <q-btn label="Kembali" size="sm" color="grey-7"  v-close-popup/>
                            &nbsp;
                            <q-btn type="submit" label="Hapus" size="sm" color="deep-orange-7" v-close-popup/>

                          </form>
                      </q-card-section>
                    </q-card>
                  </q-dialog>

            <!-- ================================================ MODAL HAPUS ================================================ -->

          <!-- =================================================== MODAL =========================================================== -->

  </div>
</template>

<style>
</style>

<script>
export default {
  name: 'PelakuPage',
  data() {
    return {
      form : {
        id : '',
        nama : '',
        nik : '',
        brand : '',
        badan : '',
        email : '',
        hp : '',
        kecamatan : '',
        des_kel : '',
        alamat : '',
        profil : null,
        file : '',
        file_old : '',
      },

      profile : {
        menu_klp : '',
      },
      rute : '',

      list_data : [],
      list_kecamatan : [],
      list_des_kel : [],

      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_add: false,
      mdl_lihat: false,
      mdl_edit: false,
      mdl_hapus: false,
    }
  },
  methods: {

    getView : function(){
      this.$store.commit('showLoading');
      
      if (this.profile.menu_klp == 17) {
        this.rute = "viewAdmin"
      } else {
        this.rute = "viewUser"
      }
      
      fetch(this.$store.state.url.URL_PELAKU + this.rute, {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    addData : function() {
      fetch(this.$store.state.url.URL_PELAKU + "addData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'light-blue-7', 'check_circle_outline');
          console.log(res_data);
          this.getView();
      });
    },

    editData : function(){
      fetch(this.$store.state.url.URL_PELAKU + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Mengedit Data', 'amber-7', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(){
      fetch(this.$store.state.url.URL_PELAKU + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.form.id})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'deep-orange-7', 'check_circle_outline');
          this.getView();
      });

    },

    getKecamatan : function (){
      fetch(this.$store.state.url.URL_WILAYAH + "kecamatan", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
      })
      .then(res => res.json())
      .then(res_data => {
        this.list_kecamatan = res_data;
        console.log(this.list_kecamatan);

      });
    },

    getDesKel : function (val){
      console.log(val);
      fetch(this.$store.state.url.URL_WILAYAH + "des_kel", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          kecamatan_id : val.kecamatan_id
        })
      })
      .then(res => res.json())
      .then(res_data => {
        this.list_des_kel = res_data;
        console.log(this.list_des_kel);

      });
    },

    selectData: function(data) {
      console.log(data);
      this.form.id = data.id
      this.form.nama = data.nama
      this.form.nik = data.nik
      this.form.brand = data.brand
      this.form.badan = data.badan
      this.form.email = data.email
      this.form.hp = data.hp
      this.form.kecamatan = data.kecamatan_id
      this.form.des_kel = data.des_kel_id
      this.form.alamat = data.alamat
      this.form.profil = data.profil
      this.form.createdAt = data.createdAt
      this.form.editedAt = data.editedAt
      this.form.userId = data.userId
    },

    // ====================================== PAGINATE ====================================
    Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },

        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },


    // ====================================== PAGINATE ====================================

  },
  mounted() {
    var get_profile = JSON.parse(localStorage.profile);
      this.profile.menu_klp = get_profile.profile.menu_klp;
      console.log(this.profile.menu_klp);
    this.getView();
    this.getKecamatan();
    // this.getDesKel();
  }
}
</script>
